module.exports = "\u0003�RCopyright 1990-2009 Adobe Systems Incorporated.\nAll rights reserved.\nSee ./LICENSE�\u000bKSC-Johab-Ha\u0010�2\u0001�x\u0001\u0000�z\u0000\u0000�\u0000\u0002\u0002�{\u0001\u0000�~\u0004\u000b�-\u0000�\u000b�5\u0000�\f\u0006\u0001�\r\u0002\u0000�\u000f\u0001\u0000�\u0010\u000b\u0005�\u0011\u001b\u0000�\u0017\u0001\u0000�\u0018\u0001\u0000�\u0019-\u0003�\u001a"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/pdfjs-dist/cmaps/KSC-Johab-V.bcmap
// module id = 1096
// module chunks = 63